import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  skeletonContainer: {
    overflow: 'hidden',
  },
  waveOverlay: {
    backgroundColor: colors.overlay.whiteOverlay,
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
});

export const getSkeletonBackgroundColor = () => colors.neutral.mist || '#E1E9EE';

export default styles;



